let _ = t => t,
  _t,
  _t2;
import { css, keyframes } from 'styled-components';
export function rotate(to, from) {
  return ({
    $on
  }) => css(_t || (_t = _`
        transform: rotate(${0}deg);
        transform-origin: 50% 50%;

        transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    `), $on ? from : to);
}
export function rotate360(start = 0) {
  return keyframes(_t2 || (_t2 = _`
        from {
            transform: rotate(${0}deg);
        }

        to {
            transform: rotate(${0}deg);
        }
    `), start, start + 360);
}